import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import useEventListener from 'hooks/useEventListener';

/**
 * Returns an event handler that executes the callback only if the
 * event's target is outside of, or equal to the provided excluded element
 *
 * @param {object} excludedElementRef - A React ref (as obtained from `useRef` or `createRef`) to an element that should be excluded from triggering the `onClick` callback
 * @param {Function} callback - Function that's called when the event originated outside of the excluded element
 */

export function getOutsideTargetCallback(excludedElementRef, callback) {
  return function (event) {
    var excludedRefs = Array.isArray(excludedElementRef) ? excludedElementRef : [excludedElementRef];
    var _iterator = _createForOfIteratorHelper(excludedRefs),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var ref = _step.value;
        var excludedElement = ref === null || ref === void 0 ? void 0 : ref.current;

        // Bail out if the clicked element or the currently focused element
        // is inside of excludedElement. We need to check the focused element
        // to prevent an issue in Chrome where initiating a drag inside of an
        // input (to select the text inside of it) and ending that drag outside
        // of the input fires a click event, breaking our excludedElement rule.
        if (excludedElement && (excludedElement === event.target || excludedElement === document.activeElement || excludedElement.contains(event.target) || excludedElement.contains(document.activeElement))) {
          return null;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    callback(event);
  };
}

/**
 * Handle clicks that occur outside of the element provided in the first parameter
 *
 * @param {object} excludedElementRef - A React ref (as obtained from `useRef` or `createRef`) to an element that should be excluded from triggering the `onClick` callback
 * @param {Function} onClick - Function that's called when a click occurs outside of the excluded element
 * @param {bool} [isEnabled=true] - Set to false to disable the hook
 */

function useOnClickOutside(excludedElementRef, onClick, isEnabled) {
  useEventListener('click', getOutsideTargetCallback(excludedElementRef, onClick), {
    isEnabled: isEnabled
  });
}
export default useOnClickOutside;